import Vue from 'vue';
//import Vuetify from 'vuetify';
import Vuex from 'vuex';
import App from './App';
import router from './router';
import store from './store';
import IdleVue from 'idle-vue';
import i18n from './i18n';
import '../node_modules/mdi/css/materialdesignicons.min.css';
import { initialize, isAnyStudioOpen } from './functions/crossPopup';
import SlimCropper from 'vue-slim-cropper'


Vue.config.productionTip = false;
const idleEventsHub = new Vue();
initialize();

Vue.use(Vuex);
Vue.use(IdleVue, {
    idleTime: 15 * 1000 * 60,
    startAtIdle: false,
    eventEmitter: idleEventsHub,
});
Vue.use(SlimCropper)

router.beforeEach((to, from, next) => {
    if (window.confirmBeforeRouteChange) {
        if (confirm(i18n.t('app.closeStudioConfirm'))) {
            window.confirmBeforeRouteChange = false;
            next();
        }
    } else {
        next();
    }
});

new Vue({
    el: '#app',
    router,
    store,
    i18n,
    template: '<App/>',
    components: {
        App,
    },
});
